import { http } from './http_service';

// Get all
export function all(){
    return http().get('/tax-table');
}
// Get all active
export function allActive(){
    return http().get('/tax-table/active');
}
// Get Single
export function single(id){
    return http().get(`/tax-table/${id}`);
}
// Add one
export function add(data){
    return http().post('/tax-table', data)
}
// Update
export function update(id, data){
    return http().put(`/tax-table/${id}`, data)
}
// Delete one
export function deleteSingle(id){
    return http().delete(`/tax-table/${id}`);
}

export function storeTaxTable(){
    return http().get('/tax-table')
    .then(response => {
        if(response.status === 200){

            localStorage.removeItem('tax-table');
            localStorage.setItem('tax-table', JSON.stringify(response.data));
        }

        return response.data;
    });
}
